import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { logSafeErrorWithoutCustomerDataWrapper } from '@atlassian/jira-polaris-lib-errors/src/common/utils/index.tsx';
import { PRODUCT_START_TIMESTAMP } from '../../constants.tsx';
import type { Props, State } from '../../types.tsx';

export const loadProductUsageStartTimestamp =
	(): Action<State, Props, Promise<string | undefined>> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		// usage timestamp already loaded
		if (getState().productUsageStartTimestamp) {
			return;
		}

		try {
			const { isoDateString: productUsageStartTimestamp } = await getUserProperty<{
				isoDateString: string;
			}>(accountId, PRODUCT_START_TIMESTAMP);

			const state = getState();

			setState({
				...state,
				productUsageStartTimestamp,
			});
		} catch (error) {
			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.roadmaps.introduction.spotlight.dismissed',
				`Failed to get user property with key: ${PRODUCT_START_TIMESTAMP}`,
				error instanceof Error ? error : undefined,
			);
		}
		return getState().productUsageStartTimestamp;
	};
